import React from "react";
import { Snackbar, Alert } from "@mui/material";
var Notification = function (_a) {
    var isOpen = _a.isOpen, type = _a.type, message = _a.message, handleClose = _a.handleClose;
    return (React.createElement(Snackbar, { open: isOpen, autoHideDuration: 3000, anchorOrigin: { vertical: "bottom", horizontal: "center" }, onClose: handleClose },
        React.createElement(Alert, { onClose: handleClose, variant: "filled", severity: type ? type : "info" }, message)));
};
export default Notification;
//# sourceMappingURL=Notification.js.map